// Всплывающее окно внизу экрана
import storage from "../storage";
import dom from "../dom";
import analytics from "../marketing/analytics";

const template = `
    <div class="bottom-popup bottom-popup--blue" v-if="!closed" data-ref="bottom-popup">
        <a
            href="#"
            class="bottom-popup__close"
            @click.prevent="close()"
            data-ref="bottom-popup-close"
        >
            <i class="fa fa-close"></i>
        </a>
        <div class="bottom-popup__header">
            <slot name="header"></slot>
        </div>
        <div class="bottom-popup__text hidden-mobile">
            <slot></slot>
        </div>
        <a
            class="button-clean button-clean--white bottom-popup__button"
            :href="link"
            target="_blank"
            v-html="linkText"
            @click="click"
            data-ref="bottom-popup-button"
        >
        </a>
    </div>`;

const props = {
    link: String,
    linkText: String,
    uid: String,
};

const data = function () {
    return { closed: false };
};

const methods = {
    hide() {
        this.closed = true;
        storage.set(this.storageName, 1);
    },

    close() {
        this.hide();
        this.sendGoal(`${this.goalBaseName}CLOSE`);
    },

    click() {
        this.hide();
        this.sendGoal(`${this.goalBaseName}CLICK`);
        return true;
    },

    sendGoal(goal) {
        analytics.reachGoalOnce(goal, this.uid);
    },
};

const mounted = function () {
    if (storage.get(this.storageName)) {
        this.closed = true;
        return;
    }
    dom.callAfterWindowLoaded(() => {
        this.sendGoal(`${this.goalBaseName}SHOW`);
    });
};

const computed = {
    storageName() {
        return `${this.$root.$options.name}_CLOSED_${this.uid}`;
    },

    goalBaseName() {
        return `${this.$root.$options.name}_BOTTOM_POPUP_`;
    },
};

export default {
    props,
    data,
    template,
    methods,
    mounted,
    computed,
};
